<script setup lang="ts">
import { ref } from "vue";
import { UiButton, UiIcon, UiText } from "@shopexperts/shared";
import EmailChangeAside from "@/app/components/settings/EmailChangeAside.vue";
import { useExpertProfile } from "@/app/composables/useExpertProfile";

const { user, pendingEmailChange, requestEmailChange } = useExpertProfile();

const emailAsideOpen = ref(false);

function openEmailAside() {
    emailAsideOpen.value = true;
}
</script>

<template>
    <div class="bg-white rounded-lg border border-gray-200 p-6 w-full">
        <div class="flex flex-col">
            <div class="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
                <div>
                    <UiText variant="h6" as="label" class="block" text="Email" />
                    <UiText variant="p" as="p" class="mt-1 font-medium">
                        {{ user?.email }}
                    </UiText>
                </div>
                <UiButton variant="ghost" shape="square" @click="openEmailAside">
                    <template #before_label>
                        <UiIcon name="pencil" class="w-4 h-4" />
                    </template>
                </UiButton>
            </div>

            <div v-if="pendingEmailChange" class="mt-2 flex items-center gap-2 text-amber-600">
                <UiIcon name="info-circle" class="w-4 h-4" />
                <UiText variant="caption" as="span">
                    Pending change to {{ pendingEmailChange.new_email }}
                </UiText>
            </div>
        </div>

        <EmailChangeAside v-model="emailAsideOpen" :request-email-change="requestEmailChange" />
    </div>
</template>
